export type UserRole =
  | 'super_admin'
  | 'admin_deputi'
  | 'admin_stin'
  | 'admin_binda'
  | 'user'
  | 'auditor'

export interface User {
  username: string
  role: UserRole
  name: string
  unit: string
}

export const DEMO_USERS: User[] = [
  {
    username: 'superadmin',
    role: 'super_admin',
    name: 'Super Administrator',
    unit: 'Setuma',
  },
  {
    username: 'deputi',
    role: 'admin_deputi',
    name: 'Admin Deputi',
    unit: 'Deputi',
  },
  {
    username: 'stin_admin',
    role: 'admin_stin',
    name: 'Admin STIN',
    unit: 'STIN',
  },
  {
    username: 'binda_jatim',
    role: 'admin_binda',
    name: 'Admin BINDA Jatim',
    unit: 'BINDA Jatim',
  },
  {
    username: 'operator1',
    role: 'user',
    name: 'Operator Satker A',
    unit: 'Satker A',
  },
  {
    username: 'auditor1',
    role: 'auditor',
    name: 'Auditor Inspektorat',
    unit: 'Inspektorat',
  },
]

export const ROLE_LABELS: Record<UserRole, string> = {
  super_admin: 'Super Admin',
  admin_deputi: 'Admin Deputi',
  admin_stin: 'Admin STIN',
  admin_binda: 'Admin BINDA',
  user: 'User',
  auditor: 'Auditor',
}

export const ROLE_ACCESS: Record<UserRole, string[]> = {
  super_admin: [
    'dashboard',
    'assets',
    'reminders',
    'maintenance',
    'contracts',
    'recommendations',
    'analytics',
    'users',
    'server',
    'audit',
    'notifications',
    'reporting',
    'taskboard',
  ],
  admin_deputi: [
    'dashboard',
    'assets',
    'reminders',
    'maintenance',
    'contracts',
    'recommendations',
    'analytics',
    'notifications',
    'reporting',
    'taskboard',
  ],
  admin_stin: [
    'dashboard',
    'assets',
    'reminders',
    'maintenance',
    'contracts',
    'analytics',
    'server',
    'notifications',
    'reporting',
    'taskboard',
  ],
  admin_binda: [
    'dashboard',
    'assets',
    'reminders',
    'maintenance',
    'contracts',
    'notifications',
    'reporting',
    'taskboard',
  ],
  user: [
    'dashboard',
    'assets',
    'reminders',
    'maintenance',
    'notifications',
    'taskboard',
  ],
  auditor: [
    'dashboard',
    'assets',
    'analytics',
    'audit',
    'notifications',
    'reporting',
  ],
}

export const getRoleLabel = (role: UserRole): string => {
  return ROLE_LABELS[role] || role
}
